import { render, staticRenderFns } from "./BtnTab.vue?vue&type=template&id=905cd79e&scoped=true&"
import script from "./BtnTab.vue?vue&type=script&lang=js&"
export * from "./BtnTab.vue?vue&type=script&lang=js&"
import style0 from "./BtnTab.vue?vue&type=style&index=0&id=905cd79e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905cd79e",
  null
  
)

export default component.exports